// ============================================
// AI 화면(/ai) 설정 및 상수
// ============================================

export const RESPONSE_FAILED_RETRY = '지금은 답변이 어려워요. 잠시 후 다시 시도해주세요.';
export const CANCELLED_RESPONSE = '요청을 중단했어요. 다시 질문해주시면 바로 확인해드릴게요!';

export const TOOL_CALLING_LOG = process.env.NODE_ENV === 'development'; // 자동 환경 분기
